export default "__VITE_ASSET__CFu3qLpS__"